// Vuex
import consts from "@/consts.js";
import Request from './request';

async function fetchAll() {
  return Request('get', "api/organizations",{ limit: consts.limitAll });
}

async function tree() {
  return Request('get', "api/organizations/tree");
}

async function save(id, data) {
  if (id) {
    return Request('post', "api/organizations/edit?id=" + id, data);
  } else {
    return Request('post', "api/organizations/add", data);
  }
}

async function del(id) {
  return Request('get', "api/organizations/delete/", id ? { id: id } : {});
}

export default {
  fetchAll,
  tree,
  save,
  del,
};